import React from "react";
import { useNavigate } from "react-router-dom";
import "./styles/ProductsPage.css";

const products = [
{
id: 1,
name: "GTELINQ",
description:
"Unified enterprise communication and collaboration platform.",
},
{
id: 2,
name: "Hiring Hub",
description:
"End-to-end recruitment, onboarding, and candidate management.",
},
{
id: 3,
name: "Payroll",
description:
"Automated payroll processing, compliance, and salary management.",
},
{
id: 4,
name: "CRM",
description:
"Customer relationship management and sales pipeline automation.",
},
{
id: 5,
name: "Inventory Management",
description:
"Real-time inventory tracking and stock optimization.",
},
{
id: 6,
name: "Purchase & Procurement",
description:
"Vendor management, procurement workflows, and purchasing control.",
},

{
id: 7,
name: "Warehouse Management",
description:
"Warehouse operations, stock movement, and logistics visibility.",
},

];

const ProductsPage = () => {
const navigate = useNavigate();

const handleSelectProduct = (product) => {
  if (
    product.name === "GTELINQ" ||
    product.name === "Hiring Hub"
  ) {
    navigate("/pricing", {
      state: {
        selectedProduct: product,
      },
    });
  }
};

return ( <div className="products-page"> <div className="products-container">


    <button
      className="products-back-btn"
      onClick={() => navigate("/")}
    >
      ← Back to Home
    </button>

    <div className="products-hero">

      <span className="products-badge">
        ENTERPRISE SOFTWARE SUITE
      </span>

      <h1>
        Business Applications
        <br />
        Built For Growth
      </h1>

      <p className="products-subtitle">
        Explore Genesis enterprise solutions designed to
        automate operations, improve productivity, and
        accelerate business growth across every department.
      </p>

    </div>

    <div className="products-list">

      {products.map((product) => (
        <div
          key={product.id}
          className="product-row"
          onClick={() => handleSelectProduct(product)}
        >

          <div className="product-left">

            <h2>{product.name}</h2>

            <p>{product.description}</p>

          </div>

          <div className="product-right">

            <span className="product-arrow">
              →
            </span>

          </div>

        </div>
      ))}

    </div>

  </div>
</div>

);
};

export default ProductsPage;




